import { useFormik } from "formik";
import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import "./varniAcquireDonorDetails.css";
import { useDispatch } from "react-redux";
import { setDonorInfo } from "../../state/donation";
import { useNavigate } from "react-router-dom";

export default function VarniAcquireDonorDetails() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const donorDetailSchema = Yup.object().shape({
        mobile: Yup.string()
            .required('Required'),
        name: Yup.string()
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Required'),
        email: Yup
            .string()
            .email('Invalid email')
            .required('Required'),
    });

    const formik = useFormik({
        initialValues: {
            mobile: "",
            email: "",
            name: ""
        },
        validationSchema: donorDetailSchema,
        onSubmit: values => {
            dispatch(setDonorInfo({ email: values.email, mobileNumber: values.mobile, name: values.name }));
            navigate("/varni-pay");
        }
    });

    const onContinueWithoutReceiptClick = () => {
        navigate("/varni-pay");
    }

    return (<Container className="varni-acquire-donor-details">
        <Form className="container" onSubmit={e => {
            console.log("form submit");
            formik.handleSubmit();
            e.preventDefault();
        }}>
            <Form.Group as={Row} className="mb-4">
                <Form.Label column sm="3" className="formText">
                    Your Mobile
                </Form.Label>
                <Col sm="9">
                    <Form.Control className="textBoxText"
                        onChange={formik.handleChange}
                        value={formik.values.mobile}
                        name="mobile"
                        size="lg"
                        type="text"
                        placeholder="04xxxxxxxx" />
                    {formik.touched &&
                        formik.touched.mobile &&
                        formik.errors.mobile ?
                        (<span style={{ color: "red" }}>{formik.errors.mobile}</span>) : (<React.Fragment />)}
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-4">
                <Form.Label column sm="3" className="formText">
                    Your Name
                </Form.Label>
                <Col sm="9">
                    <Form.Control className="textBoxText"
                        onChange={formik.handleChange}
                        value={formik.values.name}
                        name="name"
                        size="lg"
                        type="text"
                        placeholder="Amit" />
                    {formik.touched &&
                        formik.touched.name &&
                        formik.errors.name ?
                        (<span style={{ color: "red" }}>{formik.errors.name}</span>) : (<React.Fragment />)}
                </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-4">
                <Form.Label column sm="3" className="formText">
                    Your Email
                </Form.Label>
                <Col sm="9">
                    <Form.Control className="textBoxText"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        name="email"
                        size="lg"
                        type="text"
                        placeholder="email@example.com" />
                    {formik.touched &&
                        formik.touched.email &&
                        formik.errors.email ?
                        (<span style={{ color: "red" }}>{formik.errors.email}</span>) : (<React.Fragment />)}
                </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formButtonSubmit">
                <Col sm="12">
                    <Button type="submit"
                        variant="primary"
                        size="lg"
                        className="textBoxText"
                        style={{ width: "100%" }}>Submit</Button>
                </Col>
                <Col sm="12" style={{ marginTop: "10px" }}>
                    <Button variant="secondary"
                        type="button"
                        size="lg"
                        className="textBoxText"
                        style={{ width: "100%" }}
                        onClick={onContinueWithoutReceiptClick}>Continue Without Receipt</Button>
                </Col>
            </Form.Group>
        </Form>
    </Container>);
}